<template>
  <div class="menu">
    <el-menu
      router
      unique-opened
      background-color="#304156"
      text-color="#fff"
      :default-active="activeMenu"
      active-text-color="#409EFF"
      :collapse="$store.getters.sidebarOpened"
    >
      <el-sub-menu v-for="(item,index) in menuList" :key="index" :index="item.id+''">
        <template #title>
          <template v-if="!item.meta">
            <i v-if="item.icon_cls && item.icon_cls.includes('fa-')" :class="item.icon_cls" style="margin-right:10px" />
            <el-button v-else text :icon="item.icon_cls" class="menu-icon" />
          </template>
          <template v-else>
            <i v-if="item.meta.icon && item.meta.icon.includes('fa-')" :class="item.meta.icon" style="margin-right:10px" />
            <el-button v-else text :icon="item.meta.icon" class="menu-icon" />
          </template>
          <span v-if="item.meta">{{ item.meta.title }}</span>
          <span v-else>{{ item.name }}</span>
        </template>
        <el-menu-item v-for="it in item.children" :key="it.id" :index="it.path">
          <template #title>
            <template v-if="!it.meta">
              <i v-if="it.icon_cls && it.icon_cls.includes('fa-')" :class="it.icon_cls" style="margin-right:10px" />
              <el-button v-else text :icon="it.icon_cls" class="menu-icon" />
            </template>
            <template v-else>
              <i v-if="it.meta.icon.includes('fa-')" :class="it.meta.icon" style="margin-right:10px" />
              <el-button v-else text :icon="it.meta.icon" class="menu-icon" />
            </template>
            <!-- <i :class="it.icon_cls" style="margin-right:10px"></i> -->
            <span v-if="it.meta">{{ it.meta.title }}</span>
            <span v-else>{{ it.name }}</span>
          </template>
        </el-menu-item>
      </el-sub-menu>
    </el-menu>
    <span class="swithc">
      <Hamburger />
    </span>
  </div>
</template>

<script setup>
// eslint-disable-next-line
import { getMenulist } from '@/api/menu'
import Hamburger from '@/components/Hamburger'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { ref, computed } from 'vue'
const store = useStore()
const menuList = ref([])
// eslint-disable-next-line
const collapse = ref(false)

// 计算路由表结构
// const router = useRouter()
// const routes = computed(() => {
//   const filterRoutes = filterRouters(router.getRoutes())
//   return filterRoutes
//   // return generateMenus(filterRoutes)
// })
// // console.log(routes)

// menuList.value = routes
// console.log(menuList.value)
// 计算高亮 menu 的方法
const route = useRoute()
const activeMenu = computed(() => {
  const { meta, path } = route
  if (meta.activeMenu) {
    return meta.activeMenu
  }

  return path
})

const getMentu = async() => {
  // const { data } = await getMenulist()
  menuList.value = store.getters.menus
  // menuList.value = data
}
// console.log(menuList.value)
getMentu()
</script>

<style lang="less" scoped>
.menu-icon {
  padding: 0;
  color: white !important;
  &:hover {
    background: transparent !important;
  }
}
.menu {
  position: relative;
  margin-top: 20px;
}
.swithc {
  position: absolute;
  right: 10px;
  top: -10px;
  line-height: 20px;
  width: 100%;
  text-align: right;
  display: inline-block;
  cursor: pointer;
}
</style>

